export default __webpack_public_path__ + "static/media/brass_01-2.e5ddc1bb.jpg";